var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"alert",class:{
      'alert-danger': _vm.type === 'danger',
      'alert-success': _vm.type === 'success',
      'alert-warn': _vm.type === 'warn'
    }},[_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('div',{staticClass:"close-wrapper",on:{"click":_vm.close}},[_c('icon',{staticClass:"icon-close",attrs:{"type":"close"}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e2571ad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert.vue
// module id = JlpQ
// module chunks = 22